import type { ReactNode } from "react";

/**
 * G-9.2 kit: KPI tile — one shared numeric style (tabular numerals), color
 * reserved for semantic meaning via `tone`. The -€81.52 gross profit must
 * read as a loss; everything neutral stays neutral.
 */
export function StatTile({
  label,
  value,
  tone = "neutral",
  hint,
}: {
  label: string;
  value: ReactNode;
  tone?: "neutral" | "positive" | "negative" | "warning";
  hint?: string;
}) {
  return (
    <div className="kit-stat-tile">
      <span className="kit-stat-label">{label}</span>
      <span className={`kit-stat-value tone-${tone}`}>{value}</span>
      {hint ? <span className="kit-stat-hint">{hint}</span> : null}
    </div>
  );
}
